// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__e06891dc41e4b6f49dc9","cls2":"AutoCompleteResults-cls2___ecafc4c18ff7d496e9d AutoCompleteResults-cls1__e06891dc41e4b6f49dc9"};